import { loading as loadingModule } from '../loading'

import { Actions, Module } from 'vuex-smart-module'

import { TableLoadingGetters, TableMutations, TableState } from '@/store/mixins/table'
import { CertificateService, CertificateData } from '@/api'

export type CertificateListStateTableItem = CertificateData

const loading = loadingModule.clone()

export class CertificateListState extends TableState<CertificateListStateTableItem> {
  itemsPerPageOptions = [5, 10, 15] as const
}

export class CertificateListStateGetters extends TableLoadingGetters<
  CertificateListStateActions,
  CertificateListState
> {
  get isTableItemsGet() {
    return this.state.loading.loaders.getTableItems
  }
}

export class CertificateListStateMutations extends TableMutations<CertificateListState> {}

export class CertificateListStateActions extends Actions<
  CertificateListState,
  CertificateListStateGetters,
  CertificateListStateMutations,
  CertificateListStateActions
> {
  async getTableItems() {
    const { limit, offset } = this.getters.tableParams
    const { history, count } = await CertificateService.getCertificateList({
      limit,
      offset,
    })
    this.mutations.setTableCount(count)
    this.mutations.setTableItems(history)
  }
}

export const certificateList = new Module({
  state: CertificateListState,
  getters: CertificateListStateGetters,
  mutations: CertificateListStateMutations,
  actions: CertificateListStateActions,
  modules: {
    loading,
  },
})
